var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlagUs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 32,
    height: 32,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M16 32a16 16 0 1 0 0-32 16 16 0 0 0 0 32Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M32 0H0v4h32V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AE4D51",
    d: "M32 4H0v4h32V4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M32 8H0v4h32V8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AE4D51",
    d: "M32 12H0v4h32v-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M32 16H0v4h32v-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AE4D51",
    d: "M32 20H0v4h32v-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M32 24H0v4h32v-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F548F",
    d: "M16 0H0v16h16V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AE4D51",
    d: "M32 28H0v4h32v-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "m12.36.84.53 1.63h1.71l-1.38 1.01.53 1.63-1.4-1-1.38 1 .53-1.63-1.39-1h1.72l.53-1.64ZM12.36 10.2l.53 1.63h1.71l-1.38 1 .53 1.64-1.4-1.01-1.38 1.01.53-1.63-1.39-1.01h1.72l.53-1.63ZM12.36 5.52l.53 1.63h1.71l-1.38 1.01.53 1.63-1.4-1-1.38 1 .53-1.63-1.39-1.01h1.72l.53-1.63ZM6.68.84l.53 1.63h1.72l-1.4 1.01.54 1.63-1.39-1-1.39 1 .53-1.63-1.38-1h1.71L6.68.83ZM6.68 10.2l.53 1.63h1.72l-1.4 1 .54 1.64-1.39-1.01-1.39 1.01.53-1.63-1.38-1.01h1.71l.53-1.63ZM6.68 5.52l.53 1.63h1.72l-1.4 1.01.54 1.63-1.39-1-1.39 1 .53-1.63-1.38-1.01h1.71l.53-1.63ZM.96.84l.53 1.63h1.72L1.8 3.48l.54 1.63-1.39-1-1.39 1L.1 3.48l-1.39-1H.43L.96.83ZM.96 10.2l.53 1.63h1.72l-1.4 1 .54 1.64-1.39-1.01-1.39 1.01.53-1.63-1.39-1.01H.43l.53-1.63ZM.96 5.52l.53 1.63h1.72L1.8 8.16l.54 1.63-1.39-1-1.39 1L.1 8.16l-1.39-1.01H.43l.53-1.63Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M0 0h32v32H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagUs);
export default __webpack_public_path__ + "static/media/flag-us.73b67fc937c1027c070067220a7aa154.svg";
export { ForwardRef as ReactComponent };